import {
  FilterField,
  REALITY_FIELD_NAMES,
} from "../../../smartsetter-utils/filters-dialog/data"
import { fieldLabel } from "../../../smartsetter-utils/filters-dialog/filterSchema"
import { isAccountOwner, isConcierge } from "../../users/accountRole"
import {
  CalledByFilterBody,
  LastCallOutcomeFilterBody,
  SchemaBody,
} from "../components/leadFilterFields"

export function showConciergeCallStats(profile) {
  return isConcierge(profile) || isAccountOwner(profile)
}

export const CONCIERGE_CALL_FILTER_FIELDS = [
  REALITY_FIELD_NAMES.CALL_PERFORMED_BY,
  REALITY_FIELD_NAMES.CONCIERGE_DIAL_COUNT,
  REALITY_FIELD_NAMES.CONCIERGE_LAST_DIALED_AT,
  REALITY_FIELD_NAMES.CONCIERGE_LAST_DISPOSITION,
].map((fieldName) => new FilterField(fieldName, fieldLabel(fieldName)))

export const CONCIERGE_CALL_FILTER_BODY_MAP = {
  [REALITY_FIELD_NAMES.CALL_PERFORMED_BY]: CalledByFilterBody,
  [REALITY_FIELD_NAMES.CONCIERGE_DIAL_COUNT]: SchemaBody,
  [REALITY_FIELD_NAMES.CONCIERGE_LAST_DIALED_AT]: SchemaBody,
  [REALITY_FIELD_NAMES.CONCIERGE_LAST_DISPOSITION]: LastCallOutcomeFilterBody,
}

export function conciergeCallFiltersForProfile(profile) {
  if (!showConciergeCallStats(profile)) {
    return []
  }
  return CONCIERGE_CALL_FILTER_FIELDS
}

export function mergeLeadFilterConfig(baseFields, baseBodyMap, profile) {
  const conciergeFields = conciergeCallFiltersForProfile(profile)
  return {
    filterFields: [...baseFields, ...conciergeFields],
    bodyMap: {
      ...baseBodyMap,
      ...(conciergeFields.length ? CONCIERGE_CALL_FILTER_BODY_MAP : {}),
    },
  }
}
